/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HostNameAndXmlLinkData } from './HostNameAndXmlLinkData';
import {
    HostNameAndXmlLinkDataFromJSON,
    HostNameAndXmlLinkDataFromJSONTyped,
    HostNameAndXmlLinkDataToJSON,
    HostNameAndXmlLinkDataToJSONTyped,
} from './HostNameAndXmlLinkData';

/**
 * 
 * @export
 * @interface UpgatesIntegrationInput
 */
export interface UpgatesIntegrationInput {
    /**
     * 
     * @type {Array<HostNameAndXmlLinkData>}
     * @memberof UpgatesIntegrationInput
     */
    hostNameAndXmlLinkList?: Array<HostNameAndXmlLinkData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationInput
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationInput
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationInput
     */
    refundedOrderStatuses?: Array<string>;
}

/**
 * Check if a given object implements the UpgatesIntegrationInput interface.
 */
export function instanceOfUpgatesIntegrationInput(value: object): value is UpgatesIntegrationInput {
    return true;
}

export function UpgatesIntegrationInputFromJSON(json: any): UpgatesIntegrationInput {
    return UpgatesIntegrationInputFromJSONTyped(json, false);
}

export function UpgatesIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameAndXmlLinkList': json['hostNameAndXmlLinkList'] == null ? undefined : ((json['hostNameAndXmlLinkList'] as Array<any>).map(HostNameAndXmlLinkDataFromJSON)),
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
    };
}

export function UpgatesIntegrationInputToJSON(json: any): UpgatesIntegrationInput {
    return UpgatesIntegrationInputToJSONTyped(json, false);
}

export function UpgatesIntegrationInputToJSONTyped(value?: UpgatesIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameAndXmlLinkList': value['hostNameAndXmlLinkList'] == null ? undefined : ((value['hostNameAndXmlLinkList'] as Array<any>).map(HostNameAndXmlLinkDataToJSON)),
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
    };
}

